﻿window.cBuilderEmailWidgetRGPDSource = function (option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetrgpdsource'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>RGPD:Source email</div>").appendTo($DivBt)
        $DivBt.attr("title", "RGPD:<b>Ajouter la source de l'adresse email</b><br/>Affiche au destinataire d’où provient son adresse email (site internet, annuaire, salon…). Cette information est obligatoire au premier mail envoyé. La source est reprise automatiquement de la fiche contact.<br/>Cette information n'est pas affichée si vous avez déjà écrit à ce contact dans un précédent mailing.")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetrgpdsource'>")
        $("<!-- DEBUT RGPD source email -->").appendTo(option.element)
        var $Td = $("<td valign='top' style='word-break:break-word;with:100%;' width='100%' class='bodywidget tdwidget widgetheightauto'></td>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("p")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget RGPDpopsoftAsourceemail'/>").appendTo($Tr)
        $Td.text("votre adresse professionnelle a été obtenue via ...(affiché au 1er envoi, sinon vide)")

        $("<!-- FIN RGPD source email -->").appendTo(option.element)
    }

    this.nom = "RGPD:Source email"
    this.icone = "fas fa-binoculars"

    var dxBuilderSaisieHtml = null
    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()
        $("<div style='font-family:barlow condensed;'/>").appendTo(contentElement).html("Source de l’adresse (RGPD)<br/>Affiche au destinataire d’où provient son adresse email (site internet, annuaire, salon…).<br/>Obligatoire au premier contact (premier envoi de mailing). La source est reprise automatiquement de la fiche contact.<br/><br/>Si ce n'est pas le premier envoi pour cette email, la source n'est pas spécifié et ce widget est vide.")
    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()
        dxBuilderSaisieHtml = null

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }
        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Style du texte:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleFont({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            value: jsonCssData,
            showAlign: false,
            allowDefaut: true,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value != null && value.value.length > 0) { jsonCssDataOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataOriginalValue[value.prop] }
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                option.parent.mGetContenuWidget().css(prop, jsonCssData[prop])
                //if (prop == "text-align") option.parent.mGetContenuWidget().find("td").css(prop, jsonCssData[prop])
            } else {
                option.parent.mGetContenuWidget().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("p", prop))
                //if (prop == "text-align") option.parent.mGetContenuWidget().find("td").css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("p", prop))
            }
        }
    }

}